import {
    NestedField,
} from 'app/types/form.types'
import {
    LocationType,
} from 'app/enums/label.enums'
import {
    LocationFormFields,
} from '../LocationForm.types'

const getLocationFieldDetails = ({
    isNew,
    isProspect,
    orignalIsProspect,
    isAddress,
    isProspectDisabled,
}): NestedField<LocationFormFields>[] => {
    const prospect: NestedField<LocationFormFields> = {
        name: 'isProspect',
        componentName: 'Switch',
        disabled: isProspectDisabled || (!isNew && orignalIsProspect === false),
        labelKey: 'IS_PROSPECT',
    }

    const locationFields: NestedField<LocationFormFields> = {
        name: 'locationName',
        componentName: 'InputSingleline',
        required: true,
        labelKey: 'LOCATION',
    }
    const locationRules: NestedField<LocationFormFields> = {
        name: 'locationNameRule',
        componentName: 'InputRule',
        rule: 'Name + City + (Country code)',
        example: 'Kuehne & Nagel Mechelen (BE)',
        labelKey: 'RULE',
    }

    const isShippingLocation: NestedField<LocationFormFields> = {
        name: 'isShippingLocation',
        componentName: 'Switch',
        labelKey: 'IS_SHIPPING_LOCATION',
    }
    const portOfReference: NestedField<LocationFormFields> = {
        name: 'portOfReference',
        componentName: 'LocationObjectSelector',
        filterLocationType: [
            LocationType.AIRPORT,
            LocationType.SEAPORT,
        ],
        isShippingLocation: true,
        labelKey: 'PORT_OF_REFERENCE',
    }

    return [
        locationFields,
        !isProspect ? locationRules : undefined,
        isAddress ? prospect : undefined,
        !isProspect ? isShippingLocation : undefined,
        isAddress ? portOfReference : undefined,
    ].filter(Boolean)
}

export default getLocationFieldDetails
